var TAGS = null;
var AllTags = [];
function onDocumentReady() {
    initialize(document.getElementById('content-exchange-tag-labels'));
}

function initialize(dataElement) {
    if (!dataElement) {
        return false;
    }

    TAGS = JSON.parse(dataElement.textContent);
    jQuery.each( TAGS, function (i,e){
        if(e.tags && e.tags.length > 0){
            jQuery.each( e.tags, function (i,tag){
                AllTags.push(tag);
            })
        }else{
            AllTags.push(e);
        }
    })
}

function onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
}

export function findTagByName(tags, tagName) {
    let ret = null;
    let foundTags = findTagsByName(tags, tagName);

    if (foundTags) {
        ret = foundTags.pop();
    }

    return ret;
}

export function findTagsByName(tags, tagName) {
    if (!Array.isArray(tags)) {
        return null;
    }

    return tags.filter(t => t.indexOf(tagName) === 0);
}

export function getTagValue(tags, tagName) {
    let ret = null;
    let found = findTagByName(tags, tagName);

    if (found) {
        ret = found.split(':').pop();
    }

    return ret;
}

export function getTagLabel(tags, tagName) {
    let ret = null;
    let found = findTagByName(tags, tagName);
    if (found) {
        found = found.split(tagName+':')[1] ?? found;
        let allTag = getAllTagLabel(tagName);
        ret = allTag.filter(t => t.tag === found).pop();
        if (ret) {
            ret = ret.tag_label;
        }
    }

    return ret;
}

function getAllTagLabel(tagName){
    let tagReturn = [];
    jQuery.each( TAGS, function (i,e){
        if(e.tag_group_prefix  == tagName){
            jQuery.each( e.tags, function (i,tag){
                tagReturn.push(tag);
            })
        }
    })

    return tagReturn;
}

export function getTagIcon(tag) {

    let tagItem = tag && tag.split('cxproduct:')[1] ? tag.split('cxproduct:')[1] : tag;
    if(!tagItem){
        tagItem = tag;
    }
    let found = AllTags.filter(t => t.tag === tagItem).pop();

    if (found && found.icon) {
        return found.icon.url ? found.icon.url : found.icon;
    } else {
        return null;
    }
}

export function getPageFeatureLevel(p) {
    let ret = getTagValue(p.tags, 'cxfeatured');

    if (ret === null) { // if cxfeatured is null it breaks the sorting
        ret = 1;
    }

    return parseInt(ret, 10);
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
